import styled, { css } from 'styled-components';

export type InlineRenameVariant = 'navbar' | 'panelTitle' | 'chatHeader' | 'island' | 'fontCard';

export const RenameOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 0;
`;

const selectionStyle = css`
	&::selection {
		background: ${({ theme }) => theme.blue[500]}33;
	}
`;

export const Wrapper = styled.div<{ $variant: InlineRenameVariant; $raised?: boolean }>`
	display: flex;
	align-items: center;
	min-width: 0;
	cursor: text;

	${({ $raised }) =>
		$raised &&
		css`
			position: relative;
			z-index: 1;
		`}

	${({ $variant }) =>
		$variant === 'navbar' &&
		css`
			height: var(--navbar-height);
		`}

	${({ $variant }) =>
		$variant === 'panelTitle' &&
		css`
			flex: 1;
		`}

	${({ $variant }) =>
		$variant === 'chatHeader' &&
		css`
			flex: 1;
			min-width: 0;
		`}
`;

export const Display = styled.span<{ $variant: InlineRenameVariant }>`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	${({ $variant, theme }) => {
		switch ($variant) {
			case 'navbar':
				return css`
					flex: 1;
					min-width: 0;
					margin: 0 0 0 6px;
					height: var(--navbar-height);
					line-height: var(--navbar-height);
					font-size: 14px;
					font-family: 'Inter', sans-serif;
					font-weight: 500;
					color: ${theme.gray[1000]};
				`;
			case 'panelTitle':
				return css`
					flex: 1;
					font-size: 14px;
					font-weight: 500;
					color: ${theme.gray[1000]};
				`;
			case 'chatHeader':
				return css`
					font-size: 14px;
					font-family: 'Inter', sans-serif;
					font-weight: 500;
					color: ${theme.gray[1000]};
					max-width: 100%;
				`;
			case 'island':
				return css`
					font-size: 14px;
					font-weight: 400;
					color: ${theme.gray[1000]};
					max-width: 160px;
				`;
			case 'fontCard':
				return css`
					font-size: 13px;
					font-weight: 600;
					color: ${theme.gray[600]};
					text-transform: uppercase;
					letter-spacing: 0.04em;
				`;
		}
	}}
`;

export const EditInput = styled.span<{ $variant: InlineRenameVariant }>`
	background: transparent;
	border: none;
	outline: none;
	padding: 0;
	white-space: pre;
	overflow: hidden;
	min-width: 1ch;
	${selectionStyle}

	${({ $variant, theme }) => {
		switch ($variant) {
			case 'navbar':
				return css`
					flex: 1;
					min-width: 0;
					margin: 0 0 0 6px;
					font-size: 14px;
					font-weight: 500;
					font-family: 'Inter', sans-serif;
					color: ${theme.gray[1000]};
					overflow: hidden;
				`;
			case 'panelTitle':
				return css`
					flex: 1;
					width: 100%;
					font-size: 14px;
					font-weight: 500;
					font-family: inherit;
					color: ${theme.gray[1000]};
				`;
			case 'chatHeader':
				return css`
					font-size: 14px;
					font-family: 'Inter', sans-serif;
					font-weight: 500;
					color: ${theme.gray[1000]};
					max-width: 100%;
				`;
			case 'island':
				return css`
					font-size: 14px;
					font-weight: 400;
					font-family: inherit;
					color: ${theme.gray[1000]};
					max-width: 160px;
					display: inline-block;
				`;
			case 'fontCard':
				return css`
					flex: 1;
					max-width: 320px;
					font-size: 13px;
					font-weight: 600;
					color: ${theme.gray[600]};
					text-transform: uppercase;
					letter-spacing: 0.04em;
					font-family: inherit;
				`;
		}
	}}
`;
